// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "工控组态及现场总线技术",
      "tec": "赵韦仑",
      "week": "1-6周",
      "add": "实训楼F座102自控"
    },
    {
      "sub": "工业机器人应用虚拟仿真技术",
      "tec": "侯欣明",
      "week": "1-8周",
      "add": "实训楼F座103自控"
    },
    0,
    0,
    0
  ],
  "2": [
    {
      "sub": "FMS柔性控制系统安装与调试",
      "tec": "刘慧洁",
      "week": "1-8周",
      "add": "实训楼F座102自控"
    },
    {
      "sub": "工业机器人应用工程",
      "tec": "施昭",
      "week": "1-8周",
      "add": "实训楼F座202自控"
    },
    {
      "sub": "智能制造技术",
      "tec": "刘炜",
      "week": "1-8周",
      "add": "实训楼F座201自控"
    },
    0,
    0
  ],
  "3": [
    {
      "sub": "工业机器人工作站系统集成",
      "tec": "李丽霞",
      "week": "1-10周",
      "add": "实训楼F座102自控"
    },
    {
      "sub": "工控组态及现场总线技术",
      "tec": "赵韦仑",
      "week": "1-6周",
      "add": "实训楼F座201自控"
    },
    0,
    0,
    0
  ],
  "4": [
    {
      "sub": "智能制造技术",
      "tec": "刘炜",
      "week": "1-8周",
      "add": "实训楼F座103自控"
    },
    {
      "sub": "工业机器人应用工程",
      "tec": "施昭",
      "week": "1-8周",
      "add": "实训楼F座402信息"
    },
    {
      "sub": "FMS柔性控制系统安装与调试",
      "tec": "刘慧洁",
      "week": "1-8周",
      "add": "实训楼F座201自控"
    },
    0,
    0
  ],
  "5": [
    {
      "sub": "工业机器人应用虚拟仿真技术",
      "tec": "侯欣明",
      "week": "1-8周",
      "add": "实训楼F座201自控"
    },
    {
      "sub": "工业机器人工作站系统集成",
      "tec": "李丽霞",
      "week": "1-10周",
      "add": "实训楼F座201自控"
    },
    0,
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
